module.exports = __webpack_public_path__ + "static/media/sakaneMabroukAV.eed77c25.jpg";